var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMinimize(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 7,
    viewBox: "0 0 26 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.563.473H2.438C1.091.473 0 1.448 0 2.65v1.453c0 1.202 1.092 2.178 2.438 2.178h21.125c1.345 0 2.437-.976 2.437-2.178V2.65C26 1.448 24.908.473 23.562.473z"
  })));
}
export default SvgMinimize;